import { gql } from "@apollo/client";
import { CHECKOUT_PREPARED_EXPRESS_FRAGMENT } from "lib/apollo/fragments";
import { createRequestContext, getClient } from "lib/apolloClient";
import type { CheckoutPreparedExpressType } from "@shared/graphql.types";

export const CHECKOUT_EXPRESS = gql`
  mutation checkoutExpress($giftMembershipDetails: GiftMembershipDetailsInput) {
    checkoutExpress(giftMembershipDetails: $giftMembershipDetails) {
      ...CheckoutPreparedExpressFragment
    }
  }
  ${CHECKOUT_PREPARED_EXPRESS_FRAGMENT}
`;

export const checkoutExpress =
  async function checkoutExpress(): Promise<CheckoutPreparedExpressType> {
    const result = await getClient().mutate<{
      checkoutExpress: CheckoutPreparedExpressType;
    }>({
      mutation: CHECKOUT_EXPRESS,
      context: createRequestContext({ sessionStrategy: "REDIRECT_TO_LOGIN" })
    });

    if (!result?.data) throw new Error("No response received");

    return result.data.checkoutExpress;
  };
